export default () => ({
  endpoint: null,

  isLoading: false,
  hasError: false,

  artifacts: [],
});
